import { render, staticRenderFns } from "./ListEventTemplate.vue?vue&type=template&id=6a27d5e9&scoped=true&"
import script from "./ListEventTemplate.vue?vue&type=script&lang=js&"
export * from "./ListEventTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a27d5e9",
  null
  
)

export default component.exports